import { Badge } from "@/components/ui/badge";

const LABELS = {
  richiesta: "Richiesta",
  confermata: "Confermata",
  completata: "Completata",
  no_show: "No-show",
  cancellata: "Annullata",
};

export function StatusBadge({ status }) {
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`status-${status} inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold`}
    >
      {LABELS[status] || status}
    </span>
  );
}

export function SourceBadge({ source }) {
  const map = {
    portale: { label: "turismo.latina.it", cls: "bg-primary/10 text-primary" },
    pubblico: { label: "Pagina pubblica", cls: "bg-sky-100 text-sky-700" },
    manuale: { label: "Manuale", cls: "bg-slate-100 text-slate-600" },
  };
  const s = map[source] || map.manuale;
  return <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-medium ${s.cls}`}>{s.label}</span>;
}
